{
  "profile": {
    "overline": "TU ESPACIO",
    "title": "Mi",
    "titleHighlight": "Perfil",
    "removePhoto": "Eliminar foto",
    "displayName": "Nombre para Mostrar",
    "displayNamePlaceholder": "¿Cómo deberíamos llamarte?",
    "timezone": "Zona Horaria",
    "selectTimezone": "Seleccionar zona horaria",
    "searchTimezone": "Buscar zona horaria...",
    "selectTimezoneTitle": "Seleccionar Zona Horaria",
    "profileUpdated": "Perfil actualizado",
    "saveChanges": "GUARDAR CAMBIOS",
    "masterConsole": "Consola del Maestro",
    "masterConsoleHint": "Administra tus enseñanzas y sesiones en vivo"
  },
  "account": {
    "title": "CUENTA",
    "emailVerified": "Email verificado",
    "emailNotVerified": "Email no verificado",
    "memberSince": "Miembro desde"
  },
  "preferences": {
    "title": "PREFERENCIAS DE PRÁCTICA",
    "notSet": "Preferencias aún no configuradas",
    "setupHome": "Configurar en la página de Inicio",
    "practices": "Prácticas",
    "preferredTime": "Horario Preferido",
    "goals": "Objetivos",
    "format": "Formato"
  },
  "quickLinks": {
    "favorites": "Favoritos",
    "following": "Siguiendo",
    "schedule": "Horario",
    "notifications": "Notificaciones"
  },
  "master": {
    "overline": "CONSOLA DEL MAESTRO",
    "title": "Diseña el",
    "titleHighlight": "Colectivo",
    "subtitle": "Administra tu perfil, prácticas y sesiones en vivo.",
    "identity": "IDENTIDAD",
    "displayName": "Nombre para Mostrar",
    "displayNamePlaceholder": "Cómo te ven los estudiantes",
    "biography": "Biografía",
    "biographyPlaceholder": "Tu camino espiritual y filosofía...",
    "saveUpdates": "GUARDAR CAMBIOS",
    "viewPublic": "VER PORTAFOLIO PÚBLICO",
    "loading": "Desbloqueando portal del maestro...",
    "libraryTab": "BIBLIOTECA",
    "manifestoTab": "MANIFIESTO",
    "communityTab": "COMUNIDAD",
    "knowledgeLibrary": "BIBLIOTECA DE CONOCIMIENTO",
    "practicesTab": "PRÁCTICAS",
    "livesTab": "SESIONES EN VIVO",
    "recordingsTab": "GRABACIONES",
    "addPractice": "Agregar Nueva Práctica",
    "addLive": "Agregar Sesión en Vivo",
    "emptyLibrary": "Tu biblioteca está vacía actualmente.",
    "noUpcoming": "No hay sesiones en vivo próximas programadas.",
    "goLive": "INICIAR SESIÓN EN VIVO",
    "rejoin": "VOLVER",
    "liveNow": "LIVE",
    "noRecordings": "Aún no hay grabaciones disponibles.",
    "playRecording": "REPRODUCIR",
    "manifestoVideo": "VIDEO MANIFIESTO",
    "currentVideo": "Video actual",
    "addManifesto": "Agregar Video Manifiesto",
    "addManifestoHint": "Preséntate a potenciales estudiantes",
    "communityFeed": "FEED DE COMUNIDAD",
    "writePost": "Escribir Nueva Publicación",
    "noPosts": "Aún no hay publicaciones. ¡Comparte tu primer pensamiento con tu comunidad!",
    "nameRequired": "El nombre es obligatorio",
    "savedTitle": "Guardado",
    "savedMessage": "Tus actualizaciones de perfil están pendientes de revisión.",
    "manifestoUpdated": "Video manifiesto actualizado exitosamente.",
    "manifestoTitleRequired": "Por favor ingresa un título para el video.",
    "deletePost": "Eliminar Publicación",
    "deletePostConfirm": "¿Estás seguro de que deseas eliminar esta publicación?",
    "deletePractice": "Eliminar Práctica",
    "deletePracticeConfirm": "¿Estás seguro de que deseas eliminar esta práctica?",
    "cancelLive": "Cancelar Sesión en Vivo",
    "deleteLive": "Eliminar Sesión en Vivo",
    "cancelLiveConfirm": "Esto cancelará la sesión y notificará a todos los usuarios suscritos. Esto no se puede deshacer.",
    "deleteLiveConfirm": "¿Estás seguro de que deseas eliminar esta sesión en vivo?",
    "failedLoadProfile": "Error al cargar el perfil",
    "failedLoadContent": "Error al cargar el contenido",
    "yourProfile": "Tu Perfil",
    "coverImage": "Imagen de Portada",
    "quickAddPractice": "Agregar Práctica",
    "quickLiveStream": "Sesión en Vivo",
    "quickNewCircle": "Nuevo Círculo",
    "quickHostEvent": "Organizar Evento",
    "quickAddPost": "Agregar Publicación",
    "createNewCircle": "Crear Nuevo Círculo",
    "noEventsThisDay": "No hay eventos este día.",
    "addToSchedule": "Agregar al Horario",
    "addToSchedulePrompt": "¿Qué te gustaría crear?",
    "event": "Evento",
    "deleteEvent": "Eliminar Evento",
    "deleteEventConfirm": "¿Estás seguro de que deseas eliminar este evento?",
    "archiveUrl": "URL de Archivo o Sesión en Vivo (Opcional)"
  },
  "masterModals": {
    "updatePractice": "Actualizar Práctica",
    "newPractice": "Nueva Práctica",
    "practiceTitle": "Título de la Práctica",
    "practiceTitlePlaceholder": "ej. Quietud Matutina Profunda",
    "videoFile": "Archivo de Video",
    "chooseVideo": "Elegir archivo de video...",
    "durationMin": "Duración (min)",
    "durationPlaceholder": "20",
    "uploading": "SUBIENDO...",
    "saveToLibrary": "GUARDAR EN BIBLIOTECA",
    "updateLive": "Actualizar en Vivo",
    "scheduleLive": "Programar en Vivo",
    "sessionTitle": "Título de la Sesión",
    "sessionTitlePlaceholder": "ej. Despertar Colectivo",
    "sessionDescription": "Descripción del Evento",
    "sessionDescriptionPlaceholder": "¿De qué tratará el evento?",
    "date": "Fecha",
    "time": "Hora",
    "timezoneLabel": "Zona horaria: {{tz}}",
    "datePlaceholder": "AAAA-MM-DD",
    "timePlaceholder": "HH:MM",
    "pastDateError": "No se puede programar una sesión en vivo en el pasado. Seleccione una fecha y hora futuras.",
    "fillAllFields": "Por favor, complete todos los campos obligatorios",
    "invalidDate": "Fecha u hora inválida",
    "coverImage": "Imagen de Portada",
    "uploadCustomCover": "Subir imagen personalizada",
    "broadcastEvent": "PUBLICAR SESIÓN EN VIVO",
    "updateManifesto": "Actualizar Manifiesto",
    "addManifestoVideo": "Agregar Video Manifiesto",
    "videoTitle": "Título del Video",
    "videoTitlePlaceholder": "ej. Bienvenido a mi práctica",
    "visibleOnProfile": "VISIBLE EN EL PERFIL",
    "hiddenFromProfile": "OCULTO DEL PERFIL",
    "saveManifesto": "GUARDAR MANIFIESTO",
    "newPost": "Nueva Publicación",
    "postLabel": "¿Qué tienes en mente?",
    "postPlaceholder": "Comparte tus pensamientos, ideas o novedades con tu comunidad...",
    "pinnedToTop": "FIJADO AL INICIO",
    "pinThisPost": "FIJAR ESTA PUBLICACIÓN",
    "publishPost": "PUBLICAR"
  },
  "subscriptions": {
    "overline": "COMUNIDAD",
    "title": "El Colectivo",
    "titleHighlight": "Conectado",
    "signInHint": "Inicia sesión para administrar tus suscripciones a maestros y no perderte nunca una sesión en vivo o una nueva práctica.",
    "loading": "Sincronizando tu círculo...",
    "noMasters": "Aún no sigues a ningún maestro. Descubre la sabiduría guiada de nuestros maestros.",
    "followingCount": "Estás conectado con {{count}} maestro",
    "followingCount_plural": "Estás conectado con {{count}} maestros",
    "explore": "Explorar Maestros",
    "exploreHint": "Encuentra maestros que resuenen con tu camino y suscríbete para mantenerte al día con su sabiduría.",
    "browseMasters": "EXPLORAR MAESTROS",
    "connectedSince": "CONECTADO DESDE {{year}}",
    "notificationsOn": "NOTIFICACIONES ACTIVADAS",
    "enableAlerts": "ACTIVAR ALERTAS"
  },
  "status": {
    "draft": "BORRADOR",
    "reviewing": "EN REVISIÓN",
    "livePortfolio": "PORTAFOLIO EN VIVO",
    "hidden": "OCULTO",
    "live": "EN VIVO"
  },
  "tabs": {
    "feed": "Feed",
    "practices": "Prácticas",
    "studio": "Estudio",
    "circle": "Círculo",
    "about": "Acerca de",
    "settings": "Ajustes",
    "profile": "Perfil",
    "favorites": "Favoritos",
    "events": "Eventos",
    "rooms": "Mis sesiones en vivo",
    "media": "Media",
    "aboutMaster": "Sobre el maestro",
    "masterChat": "Chat del maestro",
    "lightPath": "Camino de Luz",
    "programs": "Programas",
    "communityChat": "Chats del maestro",
    "journal": "Diario"
  },
  "quickActions": {
    "label": "Acciones rápidas",
    "liveBadge": "LIVE",
    "live": {
      "title": "Sesión en vivo",
      "subtitle": "Programa o empieza el directo"
    },
    "offline": {
      "title": "Evento presencial",
      "subtitle": "Lugar, fecha, número de plazas"
    },
    "media": {
      "title": "Subir contenido",
      "subtitle": "Fotos y vídeos de prácticas"
    },
    "program": {
      "title": "Crear un programa",
      "subtitle": "Ciclo de prácticas con calendario"
    }
  },
  "feedSidebar": {
    "upcomingEvent": "Próximo evento",
    "allEvents": "Todos los eventos",
    "goTo": "Ir",
    "allRecordings": "Todas las grabaciones",
    "noRecordings": "Aún no hay grabaciones de sesiones en vivo.",
    "roomRecording": "Grabación de la sesión en vivo",
    "aboutMaster": "Sobre el maestro",
    "more": "Más información",
    "participants": {
      "one": "{{count}} participante",
      "few": "{{count}} participantes",
      "many": "{{count}} participantes"
    },
    "yourNextBroadcast": "Tu próxima sesión en vivo",
    "broadcastStatus": {
      "live": "Sesión en vivo en curso",
      "due": "Ha llegado la hora de inicio",
      "scheduled": "Programada"
    },
    "broadcastCta": {
      "openRoom": "Abrir la sesión en vivo",
      "returnToRoom": "Volver a la sesión en vivo",
      "prepare": "Prepararse",
      "start": "Iniciar la sesión en vivo",
      "returnToBroadcast": "Volver a la sesión en vivo"
    },
    "startsIn": "En {{value}}",
    "unitHour": "h",
    "unitMinute": "min",
    "latestRecordings": "Últimas grabaciones"
  },
  "circleTab": {
    "search": "Buscar",
    "wallOf": "Muro de {{name}}",
    "join": "UNIRSE",
    "members": "{{count}} miembros",
    "online": "{{count}} en línea",
    "subTabs": {
      "chat": "Chat",
      "media": "Medios",
      "links": "Enlaces",
      "events": "Eventos",
      "pins": "Fijados"
    },
    "filters": {
      "all": "Todos",
      "streams": "Sesiones en vivo",
      "online": "En línea",
      "recordings": "Grabaciones"
    },
    "roomsTitle": "SESIONES EN VIVO Y GRABACIONES",
    "room": "SESIÓN EN VIVO",
    "recording": "GRABACIÓN",
    "startsIn": "EN {{time}}",
    "noRooms": "No hay sesiones en vivo ni grabaciones aún",
    "emptyChat": "Sin mensajes aún. ¡Inicia una conversación!",
    "joinToChat": "Únete al círculo para chatear",
    "sharePrompt": "Comparte con la comunidad...",
    "noCircles": "Aún no te has unido a ningún círculo",
    "connecting": "Conectando al chat…",
    "quietBeFirst": "Aquí hay silencio. Sé el primero en compartir.",
    "privateCircle": "Este chat es privado.",
    "loadFailed": "No se pudo cargar el chat.",
    "noMedia": "Aún no hay multimedia",
    "joinShort": "Unirse",
    "noMessages": "Aún no hay mensajes",
    "joinToWrite": "Únete para escribir"
  },
  "feedFilters": {
    "upcoming": "Próximos",
    "recordings": "Grabaciones",
    "saved": "Guardados",
    "newPractices": "Nuevas prácticas",
    "all": "Todo",
    "typeAll": "Todos los tipos",
    "typeLive": "Sesiones en vivo",
    "typeRooms": "Prácticas",
    "typeOffline": "Presencial"
  },
  "studio": {
    "createTitle": "Crear",
    "publicationsTitle": "Mis publicaciones",
    "chips": {
      "all": "Todo",
      "planned": "Planificadas",
      "archive": "Archivo",
      "myPractices": "Mis prácticas",
      "saved": "Guardados"
    },
    "create": {
      "quickRoom": "Empezar ahora",
      "quickRoomHint": "Entrar al instante",
      "livePractice": "Práctica en vivo",
      "livePracticeHint": "Anuncio + calendario",
      "liveSession": "Sesión en vivo",
      "liveSessionHint": "Transmitir evento",
      "offlineEvent": "Presencial",
      "offlineEventHint": "Evento presencial",
      "uploadPractice": "Subir práctica",
      "uploadPracticeHint": "A biblioteca"
    }
  },
  "editProfile": {
    "title": "Editar perfil",
    "coverLabel": "PORTADA",
    "orPickImage": "O ELIGE UNA IMAGEN",
    "noImage": "Sin imagen",
    "coversFailed": "La galería de portadas no se cargó.",
    "coverPickFailed": "No se pudo tomar esta portada. Inténtalo de nuevo, elige otra o sube la tuya.",
    "coverPickTimeout": "La portada no se cargó: el servidor no respondió. Revisa la conexión e inténtalo de nuevo o elige otra.",
    "coverRetry": "Reintentar",
    "avatarLabel": "FOTO DE PERFIL",
    "uploadPhoto": "Subir foto",
    "uploadCover": "Subir portada",
    "replaceCover": "Reemplazar portada",
    "removeCover": "Eliminar portada",
    "removeShort": "Eliminar",
    "nameLabel": "NOMBRE",
    "namePlaceholder": "Tu nombre",
    "surnameLabel": "APELLIDO",
    "surnamePlaceholder": "Tu apellido",
    "intentionLabel": "INTENCIÓN",
    "intentionPlaceholder": "Ejemplo: «Quiero meditar 10 minutos al día durante los próximos 4 meses»",
    "bioLabel": "SOBRE TI",
    "bioPlaceholder": "Unas palabras sobre ti. De dónde eres, cómo vives, qué te importa.",
    "manifestoLabel": "VIDEO MANIFIESTO",
    "uploadVideo": "Subir video",
    "videoSizeHint": "MP4, hasta ~100 MB",
    "coverThumbLabel": "Portada",
    "useCurrentFrame": "Usar el cuadro actual",
    "replaceVideo": "Reemplazar video",
    "pauseHint": "Pausa el video en el momento adecuado y pulsa «Usar el cuadro actual».",
    "loadVideoFirst": "Sube un video primero, luego elige un cuadro para la portada.",
    "uploadingVideo": "Subiendo video…",
    "socialsLabel": "CONTACTOS Y REDES",
    "websiteRow": "Sitio web",
    "cancel": "Cancelar",
    "save": "Guardar"
  },
  "hero": {
    "subscribe": "Seguir",
    "subscribed": "Siguiendo",
    "friends": "Amigos",
    "message": "Mensaje",
    "unfollow": "Dejar de seguir",
    "mutualHint": "La suscripción mutua abre el chat",
    "intentionCta": "Añade tu intención"
  },
  "native": {
    "sectionSoon": "La sección «{{section}}» llegará pronto",
    "notificationsUnread": "Notificaciones, sin leer: {{count}}",
    "shareProfile": "Perfil de {{name}} en Agapella",
    "youBadge": "ESTE ERES TÚ",
    "becomeMaster": "SER MAESTRO",
    "applicationPending": "SOLICITUD EN REVISIÓN",
    "followersWord_one": "suscriptor",
    "followersWord_many": "suscriptores",
    "followersWord_other": "suscriptores",
    "followingWord_one": "suscripción",
    "followingWord_many": "suscripciones",
    "followingWord_other": "suscripciones",
    "profileTab": {
      "aboutMe": "Sobre mí",
      "description": "Descripción",
      "notFilled": "sin completar",
      "location": "Ciudad / país",
      "notSpecified": "sin indicar",
      "timezone": "Zona horaria",
      "bySystem": "según el sistema",
      "lookingFor": "Qué busco",
      "notChosenHint": "Sin elegir: complétalo en «Configuración»",
      "interests": "Mis intereses",
      "preferences": "Preferencias",
      "eventFormat": "Formato de eventos",
      "daytime": "Hora del día",
      "timeRange": "Intervalo de tiempo",
      "language": "Idioma",
      "myPath": "Mi camino",
      "withUsSince": "Con nosotros desde",
      "roomsCreated": "Sesiones en vivo creadas",
      "followers": "Suscriptores",
      "following": "Suscripciones",
      "notChosen": "sin elegir"
    },
    "editProfile": {
      "nameMin": "Indica un nombre (mínimo 2 caracteres).",
      "saveFailed": "No se pudo guardar. Inténtalo de nuevo.",
      "name": "Nombre",
      "surname": "Apellido",
      "bioPlaceholder": "Cuenta sobre ti y tu enfoque",
      "experiencePlaceholder": "Años de práctica, a qué te dedicas",
      "educationPlaceholder": "Títulos, cursos, certificados",
      "uniquenessPlaceholder": "En qué se diferencia tu enfoque"
    },
    "basicInfo": {
      "nickname": "Apodo",
      "nicknamePlaceholder": "Por ejemplo, anna_light",
      "title": "Información básica",
      "bioPlaceholder": "Unas palabras sobre ti",
      "locationPlaceholder": "Por ejemplo: Madrid",
      "timezonePlaceholder": "Por ejemplo: Europe/Madrid"
    },
    "followersModal": {
      "loadFailed": "No se pudo cargar la lista",
      "unavailable": "La lista no está disponible por ahora. Inténtalo más tarde.",
      "noFollowers": "Aún no hay suscriptores.",
      "noFollowing": "Aún no sigue a nadie.",
      "subscribed": "Suscrito"
    },
    "userSettings": {
      "tabBasic": "Básico",
      "tabPhoto": "Foto/Portada",
      "tabExtra": "Más",
      "savedBody": "Tus preferencias se han actualizado.",
      "saveFailed": "No se pudieron guardar los cambios.",
      "editBasic": "Editar la información básica",
      "multiSelectHint": "Selección múltiple: elige todo lo que resuene contigo.",
      "interestsHint": "Cuanto más aparece un interés, más precisas son las recomendaciones.",
      "preferredDaytime": "Hora del día preferida",
      "timeRangeHint": "Hay intervalos disponibles dentro de la hora del día elegida",
      "saveChanges": "GUARDAR CAMBIOS",
      "accountHint": "Cerrar sesión termina la sesión en este dispositivo. Eliminar la cuenta es una acción que solo se deshace escribiendo a soporte."
    },
    "chatTab": {
      "notPublished": "El chat del maestro se abrirá cuando el perfil esté publicado.",
      "discussions": "Debates",
      "noDiscussions": "Aún no hay debates.",
      "noChat": "Este debate todavía no tiene chat.",
      "generalChat": "Chat general de la comunidad",
      "eventDiscussion": "Debate del evento"
    },
    "mediaTab": {
      "open": "Abrir",
      "removeFavorite": "Quitar de favoritos",
      "edit": "Editar",
      "heroSub": "Gestiona tus prácticas\ny compártelas con el mundo",
      "upload": "Subir una nueva práctica",
      "mine": "Mis medios",
      "emptyMine": "Aún no hay prácticas subidas",
      "emptyFavorites": "Aún no hay favoritos"
    },
    "circleChat": {
      "quiet": "Todo está tranquilo: empieza la conversación.",
      "noComments": "Aún no hay comentarios.",
      "placeholder": "Mensaje…"
    },
    "liveSessionsTab": {
      "recordings": "Grabaciones de sesiones en vivo",
      "management": "Gestión",
      "rooms": "Prácticas compartidas"
    },
    "rooms": {
      "scheduled": "Programada",
      "finished": "Finalizada",
      "minutesCount_one": "{{count}} minuto",
      "minutesCount_many": "{{count}} minutos",
      "minutesCount_other": "{{count}} minutos",
      "hoursCount_one": "{{count}} hora",
      "hoursCount_many": "{{count}} horas",
      "hoursCount_other": "{{count}} horas",
      "sessionsWord_one": "sesión",
      "sessionsWord_many": "sesiones",
      "sessionsWord_other": "sesiones",
      "hidden": "Oculto",
      "deleteTitle": "¿Eliminar la sesión en vivo?",
      "deleteBody": "«{{title}}» se eliminará. Esta acción no se puede deshacer.",
      "deleteFailed": "No se pudo eliminar",
      "tryAgain": "Inténtalo de nuevo.",
      "upTo": "hasta {{count}}",
      "start": "Empezar",
      "empty": "Aún no hay sesiones en vivo. Crea la primera.",
      "more": "{{count}} más",
      "calendar": "Calendario de sesiones en vivo",
      "reset": "Restablecer",
      "noRoomsThisDay": "No hay sesiones en vivo este día.",
      "activity": "Tu actividad",
      "totalRooms": "Sesiones en vivo en total",
      "totalTime": "Tiempo total",
      "thisWeek": "Esta semana",
      "editTitle": "Editar la sesión en vivo",
      "titleLabel": "Título",
      "titlePlaceholder": "Título de la sesión en vivo",
      "descPlaceholder": "De qué trata la sesión en vivo",
      "visibility": "Quién puede verla"
    },
    "feed": {
      "noPosts": "Aún no hay publicaciones",
      "publish": "Publicar",
      "photo": "Foto",
      "video": "Vídeo",
      "signInToReport": "Inicia sesión para enviar una denuncia.",
      "comments": "Comentarios",
      "noComments": "Aún no hay comentarios. Sé el primero.",
      "commentPlaceholder": "Escribe un comentario…",
      "more": "Más",
      "shareTitle": "{{name}} en Agapella",
      "share": "Compartir",
      "linkCopied": "Enlace copiado",
      "copyLink": "Copiar enlace",
      "notSent": "No se envió",
      "galleryTitle": "Acceso a la galería",
      "galleryBody": "Permite el acceso a tus medios para adjuntar un archivo.",
      "photosOrVideo": "Una publicación puede llevar fotos o un vídeo.",
      "badImage": "No se pudo leer este archivo. Sirven JPEG, PNG o WebP.",
      "tooManyPhotosTitle": "Demasiadas fotos",
      "tooManyPhotosBody": "Una publicación puede llevar como máximo {{count}} fotos.",
      "badVideo": "No se pudo leer este archivo. Elige otro vídeo.",
      "editPost": "Editar la publicación",
      "postTextPlaceholder": "Texto de la publicación",
      "replacePhoto": "Sustituir foto",
      "addPhoto": "Añadir foto",
      "restorePrevious": "Recuperar las anteriores",
      "uploadingPercent": "Subiendo… {{percent}}%",
      "videoWillBeRemoved": "El vídeo se eliminará",
      "undo": "Deshacer",
      "addVideo": "Añadir vídeo",
      "uploading": "Subiendo",
      "attachPhoto": "Adjuntar foto",
      "attachVideo": "Adjuntar vídeo"
    },
    "post": {
      "failTitle": "No se pudo",
      "editorOpenFailed": "No se pudo abrir el editor. Inténtalo más tarde.",
      "eventOpenFailed": "No se pudo abrir el evento. Inténtalo más tarde.",
      "tryLater": "Inténtalo de nuevo un poco más tarde.",
      "linkedPractices": "la biblioteca de prácticas",
      "linkedEvents": "Eventos",
      "pinned": "· Fijado",
      "menuA11y": "Menú de la publicación",
      "onlineSessionAnnouncement": "Anuncio de sesión online",
      "eventAnnouncement": "Anuncio de evento",
      "sessionEnded": "La sesión en vivo ha terminado",
      "sessionAnnouncement": "Anuncio de sesión en vivo",
      "goToSession": "Ir a la sesión",
      "unpin": "Desfijar",
      "pin": "Fijar",
      "deleteTitle": "¿Eliminar la publicación?",
      "deleteEverywhereHint": "«En todas partes» también quita la entrada de {{place}}, no solo del feed. Esta acción no se puede deshacer.",
      "deleteFeedOnly": "Solo del feed",
      "deleteEverywhere": "Eliminar en todas partes (incl. {{place}})",
      "deleteMessage": "Esta acción no se puede deshacer."
    },
    "userFeed": {
      "empty": "Aquí aparecerán tus publicaciones y lo que comparten los maestros a los que sigues.",
      "showMore": "Mostrar más",
      "deleteBody": "Desaparecerá de tu feed y de tu perfil.",
      "profileA11y": "Perfil: {{name}}",
      "openPost": "Abrir la publicación",
      "captionRequired": "Añade unas palabras: una publicación sin texto no se guardará.",
      "photoOrVideo": "Una publicación puede llevar una foto o un vídeo.",
      "galleryPhoto": "Permite el acceso a tus medios para adjuntar una foto.",
      "galleryVideo": "Permite el acceso a tus medios para adjuntar un vídeo.",
      "sourceMaster": "Maestro",
      "sourceOfficial": "Agapella",
      "sourceCommunity": "Comunidad",
      "audienceLabel": "Audiencia",
      "audiencePublic": "Para todos",
      "postLockedTitle": "Esta publicación es para los suscriptores del maestro",
      "postLockedBody": "Suscríbete a {{name}} para leerla",
      "postLockedMaster": "el maestro",
      "postLockedCta": "Suscribirse al maestro",
      "postLockedSignIn": "Inicia sesión para suscribirte al maestro y leer la publicación.",
      "postGone": "La publicación no está disponible: fue eliminada u oculta.",
      "postLoadFailed": "No se pudo abrir la publicación.",
      "audienceSubscribers": "Para suscriptores",
      "photoLimit": "Una publicación admite como máximo {{count}} fotos.",
      "reactionA11y": "Reacción {{emoji}}, {{count}} hasta ahora",
      "commentsCount": "Comentarios: {{count}}",
      "commentsEmptyAction": "Comentar",
      "commentsEmpty": "Nadie ha escrito todavía. Sé el primero.",
      "commentPlaceholder": "Escribe un comentario",
      "commentSend": "Enviar comentario"
    }
  },
  "communityChat": {
    "previewEmpty": "Aún no hay mensajes",
    "subscribeCta": "Suscríbete para participar en la conversación",
    "subscribeButton": "Suscribirse"
  },
  "journal": {
    "title": "Mis notas",
    "subtitle": "Reflexiones después de las prácticas. Solo tú puedes verlas.",
    "loadFailedTitle": "No se pudo cargar",
    "loadFailedText": "Tus notas siguen ahí: la solicitud no llegó. Inténtalo de nuevo.",
    "retry": "Reintentar",
    "emptyTitle": "Aquí aparecerán tus notas",
    "emptyText": "Después de una práctica, Agapella te propondrá detenerte un momento y anotar cómo fue. Tus notas aparecerán aquí: podrás releerlas, editarlas o eliminarlas.",
    "afterPractice": "Después de una práctica",
    "afterPracticeNamed": "Después de la práctica «{{title}}»",
    "afterLiveNamed": "Después de la sesión en vivo «{{title}}»",
    "privateToMe": "Solo para mí",
    "aiMayRead": "Agapella puede leer",
    "visibilityLabel": "Quién puede leerla",
    "visibilityHint": "Agapella no ve en absoluto una nota privada.",
    "visibilityFailed": "No se pudo cambiar. La nota sigue como estaba.",
    "freeForm": "Nota libre",
    "otherAnswer": "Respuesta",
    "edit": "Editar",
    "delete": "Eliminar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "saveFailed": "No se pudo guardar. Tu texto sigue aquí: inténtalo de nuevo.",
    "emptyEdit": "No queda nada en esta nota. Si ya no la necesitas, puedes eliminarla.",
    "deleteTitle": "¿Eliminar esta nota?",
    "deleteText": "No podrás recuperarla.",
    "deleteConfirm": "Eliminar",
    "deleteFailed": "No se pudo eliminar. Inténtalo de nuevo.",
    "openA11y": "Abrir la nota del {{date}}",
    "reflection": {
      "title": "Reflexión",
      "hint": "No hace falta responder todas las preguntas, solo las que quieras.",
      "save": "Guardar",
      "saveFailed": "No se pudo guardar. Tu texto sigue aquí: inténtalo de nuevo.",
      "close": "Cerrar",
      "savedTitle": "Nota guardada",
      "savedText": "Puedes releerla, editarla u ocultarla de Agapella en tu diario, dentro de tu perfil.",
      "openJournal": "Mis notas",
      "done": "Listo",
      "offerButton": "Escribir unas líneas"
    },
    "privacy": {
      "title": "Reflexión",
      "intro": "Después de una práctica puedes detenerte un momento y anotar cómo fue. Unas preguntas guía, o una nota libre si no te apetece responderlas.",
      "readers": "Solo tú ves tus notas. Aparte decides si Agapella puede leerlas: si es así, se apoyará en ellas para sugerirte prácticas y continuar la conversación. {{privacyHint}}",
      "note": "Tu elección se guardará y no te lo preguntaremos en cada nota. Puedes cambiarla en los ajustes, y ocultar una nota concreta de Agapella desde la propia nota.",
      "aiMayRead": "Agapella puede leer",
      "privateToMe": "Solo para mí"
    }
  }
}
